import React from "react";
import { useState } from "react";
import { WalletController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { CreateOutflowModal } from "../../pages";
import { date, number, object, string } from "yup";
import { walletStore } from "../../stores";

const CreateOutflowModalContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return object({
      currencyCode: string().required("Please select a Currency"),
      amountPaid: number()
        .min(1, "Amount cannot be less than 1")
        .required("Amount is required"),
      business: string().required("Please select a business"),
      transactionReference: string().required(
        "Transaction Reference is required"
      ),
      narration: string().required("Please enter narration"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      ...values,
    };

    delete payload.businessName;

    if (!payload.invoiceNumber) {
      delete payload.invoiceNumber;
    }

    const { status, errorMessage } =
      await WalletController.createOutflow(payload);

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({ message: status });
      return closeModal();
    }

    setLoading(false);
    return MimaToastUtil.error({ message: errorMessage });
  };

  return (
    <CreateOutflowModal
      onSubmit={onSubmit}
      closeModal={closeModal}
      loading={loading}
      validationSchema={validationSchema}
    />
  );
};
export default CreateOutflowModalContainer;
